import { httpGet } from '@inner-source/cis-shared/transports';

const getProjectsWithActiveIssues = async ({ limit = 5 } = {}) =>
  httpGet('/get-projects-with-active-issues', { limit });

export default getProjectsWithActiveIssues;
